import styled from '@emotion/styled'
import { Avatar as MuiAvatar, Grid2 as Grid, Typography } from '@mui/material'
import React from 'react'

const Avatar = styled(MuiAvatar)`
  margin-right: ${props => props.theme.spacing(2)};
`

export type UserAvatarPropsOptions = {
  includeName?: boolean
}
export type UserAvatarProps = {
  firstName: string
  lastName: string
  profileImageUrl?: string | null
}
export const UserAvatar: React.FC<
  UserAvatarProps & UserAvatarPropsOptions
> = props => {
  const { firstName, lastName, profileImageUrl, includeName = false } = props
  return (
    <Grid container alignItems="center">
      {profileImageUrl ? (
        <Avatar alt="profile-image" src={profileImageUrl} />
      ) : (
        <>
          <Avatar>
            {firstName[0]}
            {lastName[0]}
          </Avatar>
        </>
      )}
      {includeName && (
        <Typography>
          {firstName} {lastName}
        </Typography>
      )}
    </Grid>
  )
}
